<template>
  <button
    type="button"
    class="flex items-center justify-center rounded-full bg-white transition-transform focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary active:scale-95"
    :class="SIZE_CLASSES[size]"
    :aria-pressed="isOnWishlist"
    :aria-label="
      isOnWishlist
        ? t('wishlist.productCard.removeFromWishlistLabel')
        : t('wishlist.productCard.addToWishlistLabel')
    "
    data-test-id="product-card-wishlist"
    @click.stop.prevent="emit('click')"
  >
    <Heart
      :class="[
        ICON_CLASSES[size],
        isOnWishlist ? 'fill-current text-red-500' : 'text-teal-900',
      ]"
      aria-hidden="true"
    />
  </button>
</template>

<script setup lang="ts">
import { Heart } from 'lucide-vue-next'
import type { ProductCardPartSize } from '~/utils/productCardMapper'

const { isOnWishlist = false, size = 'default' } = defineProps<{
  isOnWishlist?: boolean
  size?: ProductCardPartSize
}>()

const emit = defineEmits<{ click: [] }>()

const { t } = useI18n()

// `small` is a 28px circle that balances the small badge on a narrow photo;
// its ::before ring keeps the tap target at 44×44 (8px on each side).
const SIZE_CLASSES: Record<ProductCardPartSize, string> = {
  default: 'h-9 w-9',
  small: 'h-7 w-7 before:absolute before:-inset-2',
  responsive:
    'h-7 w-7 before:absolute before:-inset-2 md:h-9 md:w-9 md:before:hidden',
}

const ICON_CLASSES: Record<ProductCardPartSize, string> = {
  default: 'h-4.5 w-4.5',
  small: 'h-4 w-4',
  responsive: 'h-4 w-4 md:h-4.5 md:w-4.5',
}
</script>
